<a
  class="icon"
  [ngClass]="iconClass"
  (click)="toggleContent()"
  [attr.aria-label]="tooltipStatus"
  [attr.aria-describedby]="ariaDescribedBy | titleCaseDashesNoSpaces"
></a>
